import { useTranslation } from 'react-i18next';
import { getAsLongDateTime, getAsLongDate, removeBrowserTimezoneConversion } from '../../../services/ukgDateTime';
import './BidPeriods.scss';

/**
 * @param {{
    * requestPeriodStartDate: Date;
    * requestPeriodEndDate: Date;
    * submissionPeriodStartDate: Date;
    * submissionPeriodEndDate: Date;
    * priorityStart?: Date;
    * priorityEnd?: Date;
    * }} param0
 */
const BidPeriods = ({
    requestPeriodStartDate,
    requestPeriodEndDate,
    submissionPeriodStartDate,
    submissionPeriodEndDate,
    priorityStart,
    priorityEnd,

}) => {
    const { t } = useTranslation('bid', { keyPrefix: 'periods' });

    return (
        <div className="bid-periods-info-tooltip">
            {priorityStart && priorityEnd && (
                <>
                    <div className="bid-periods-info-row">
                        <label>{`${t('priorityStart')}: `}</label>
                        <span>{getAsLongDateTime(priorityStart)}</span>
                    </div>
                    <div className="bid-periods-info-row">
                        <label>{`${t('priorityEnd')}: `}</label>
                        <span>{getAsLongDateTime(priorityEnd)}</span>
                    </div>
                </>
            )}
            <div className="bid-periods-info-row">
                <label>{`${t('submissionStart')}: `}</label>
                <span>{getAsLongDateTime(submissionPeriodStartDate)}</span>
            </div>
            <div className="bid-periods-info-row">
                <label>{`${t('submissionEnd')}: `}</label>
                <span>{getAsLongDateTime(submissionPeriodEndDate)}</span>
            </div>
            <div className="bid-periods-info-row">
                <label>{`${t('request')}: `}</label>
                <span>{`${getAsLongDate(removeBrowserTimezoneConversion(requestPeriodStartDate))} ${t('seperator.to')} ${getAsLongDate(removeBrowserTimezoneConversion(requestPeriodEndDate))}`}</span>
            </div>
        </div>
    );
};

export default BidPeriods;
